import { Action } from '@ngrx/store'

import { TeamMemberV1 } from '../../../../api/api/models/team-member-v1'

export const ADD_TEAM_MEMBER = '[Team] Add team member'
export const ADD_TEAM_MEMBER_SUCCESS = '[Team] Add team member success'

export const LOAD_TEAM_MEMBERS = '[Team] Load team members'
export const LOAD_TEAM_MEMBERS_SUCCESS = '[Team] Load team members success'

export const LOAD_TEAM_MEMBER = '[Team] Load one team member'
export const LOAD_TEAM_MEMBER_SUCCESS = '[Team] Load one team member success'

export const DELETE_TEAM_MEMBER = '[Team] Delete team member'
export const DELETE_TEAM_MEMBER_SUCCESS = '[Team] Delete team member success'

export class LoadTeamMembers implements Action {
  readonly type = LOAD_TEAM_MEMBERS
}

export class LoadTeamMembersSuccess implements Action {
  readonly type = LOAD_TEAM_MEMBERS_SUCCESS

  constructor(public payload: { members: TeamMemberV1[] }) {
  }
}

export class LoadTeamMember implements Action {
  readonly type = LOAD_TEAM_MEMBER

  constructor(public payload: { teamMemberId: number }) {
  }
}

export class LoadTeamMemberSuccess implements Action {
  readonly type = LOAD_TEAM_MEMBER_SUCCESS

  constructor(public payload: { member: TeamMemberV1 }) {
  }
}

export class DeleteTeamMember implements Action {
  readonly type = DELETE_TEAM_MEMBER

  constructor(public payload: { teamMemberId: number }) {
  }
}

export class DeleteTeamMemberSuccess implements Action {
  readonly type = DELETE_TEAM_MEMBER_SUCCESS

  constructor(public payload: { teamMemberId: number }) {
  }
}

export class AddTeamMember implements Action {
  readonly type = ADD_TEAM_MEMBER

  constructor(public payload: { vendorUserId: number, vendorTeamId?: number }) {
  }
}

export class AddTeamMemberSuccess implements Action {
  readonly type = ADD_TEAM_MEMBER_SUCCESS

  constructor(public payload: { teamMember: TeamMemberV1 }) {
  }
}

export type MembersActions =
  LoadTeamMembers
  | LoadTeamMembersSuccess
  | LoadTeamMember
  | LoadTeamMemberSuccess
  | DeleteTeamMember
  | DeleteTeamMemberSuccess
  | AddTeamMember
  | AddTeamMemberSuccess



// WEBPACK FOOTER //
// ./src/app/shared/team/store/actions/members.actions.ts